import axios from "axios";
import Cookies from "js-cookie"

export const HOST = process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD;

// "http://localhost:5001";

// Create a new Axios instance
const api = axios.create({
  baseURL: HOST,
  // withCredentials: true,
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
});

// Access refresh token from cookies
const rfTkn = Cookies.get('token')

// Add a request interceptor to send refresh token if present
// if (rfTkn) {
api.interceptors.request.use((config) => {

  // 🔐 Generate secure timestamp key
  const secretKey = process.env.REACT_APP_AUTH_SHARED_SECRET
  const randomKey = Math.random().toString(36).substring(2, 12)
  const timestamp = Date.now().toString()
  const rawKey = `${secretKey}:${randomKey}:${timestamp}`
  const encodedKey = btoa(rawKey) // Base64 encode

  // Add mandatory headers
  config.headers["page-index"] = encodedKey;

  if (rfTkn) {
    config.headers["Authorization"] = rfTkn;
  }

  // Handle Content-Type for FormData
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  } else if (!config.headers["Content-Type"]) {
    config.headers["Content-Type"] = "application/json";
  }

  return config
})

// Add a response interceptor
api.interceptors.response.use(
  (response) => {
    // If the response was successful, there's no need to do anything
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // If the server returned a 401 status (unauthorized). if the message is not token error and this is not a retry request,
    // then refresh the token and retry the request
    if (
      error.response.data.message !== "Token Error" &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      // Retry the original request
      return api(originalRequest);
    }

    // If the error was not 401 or this was a retry request, reject the promise
    return Promise.reject(error);
  }
);

export default api;
